import { IConnectBtcResponse, IInjectedBtcProvider } from '../../types';
import { getBitgetBtcProviderStrict } from './getBitgetBtcProvider';

export async function connectBitget(): Promise<IConnectBtcResponse> {
  const provider = getBitgetBtcProviderStrict();
  const [address] = await provider.requestAccounts();
  const publicKey = await provider.getPublicKey();

  // Bitget provider refreshes the page on account change so we don't need a real implementation
  const injectedProvider: IInjectedBtcProvider = {
    ...provider,
    onAccountChange: (callback: (args: any) => void) => {
      callback(address);
    },
    removeAccountChangeListener: () => {
      // Do nothing
    },
  };

  return {
    address,
    publicKey,
    injectedProvider,
  };
}
